module.exports = __webpack_public_path__ + "img/moon_icon.d2f2833e.svg";